/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface WithSessionLength
 */
export interface WithSessionLengthOptional {
  /**
   *
   * @type {number}
   * @memberof WithSessionLength
   */
  sessionLength?: number;
}

export interface WithSessionLength extends WithSessionLengthOptional {
  /**
   *
   * @type {number}
   * @memberof WithSessionLength
   */
  sessionLength?: number;
}

export interface WithSessionLengthTrackedI {
  /**
   *
   * @type {number}
   * @memberof WithSessionLength
   */
  sessionLength?: number;
  sessionLengthIsSet: boolean;
}

transformDatesMap.set(
  "WithSessionLength",
  function (model: WithSessionLength) {},
);

export type WithSessionLengthMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  sessionLength: PropertyMeta<MetaTypeBase<number>>;
}>;

export var WithSessionLengthMeta: WithSessionLengthMetaI =
  {} as WithSessionLengthMetaI;
WithSessionLengthMeta = typeMeta("WithSessionLength", {
  sessionLength: propertyMeta(
    "sessionLength",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = WithSessionLengthMeta;

registerMeta(() => {});

export class WithSessionLengthTracked implements WithSessionLengthTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  sessionLength__I?: number = undefined;
  sessionLengthIsSet: boolean = false;
  set sessionLength(v: undefined | number) {
    if (v !== undefined) {
      this.sessionLength__I = v;
      this.sessionLengthIsSet = true;
    } else {
      this.sessionLength__I = v || undefined;
      this.sessionLengthIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionLength() {
    return this.sessionLength__I;
  }
  constructor(config?: WithSessionLengthOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: WithSessionLengthOptional,
    options?: AssignOptions,
  ): WithSessionLengthTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.sessionLength &&
      this.sessionLengthApplyFilter(optionsRequired.filter)
    ) {
      this.sessionLength = config.sessionLength;
      if (optionsRequired.unassign) this.sessionLengthIsSet = false;
      else this.sessionLengthIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WithSessionLengthTrackedI {
    const cloned = {} as WithSessionLengthTrackedI;
    if (
      this.sessionLengthIsSetDeep() &&
      this.sessionLengthApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionLengthIsSet = true;
      cloned.sessionLength = this.sessionLength;
    } else {
      //cloned.sessionLengthIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WithSessionLengthTrackedI {
    if (!this.sessionLengthApplyFilter(filter)) this.sessionLengthIsSet = false;

    return this;
  }
  sessionLengthApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WithSessionLengthMeta.sessionLength,
      WithSessionLengthMeta,
      this.sessionLength,
      this,
    );
  }
  sessionLengthIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionLengthIsSet && this.sessionLengthApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.sessionLengthIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
